import { SHA256, enc } from 'crypto-js';

export const sha256 = (message: string): string =>
  SHA256(message).toString(enc.Hex);
